import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IVendorOfferListResponse} from "../../offer/types/VendorOffersListResponse";
import {IVendorDetailOfferListParams} from "../types/IVendorDetailOfferListParams";

export const getVendorDetailOffers = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getVendorDetailOffers: builder.query<IVendorOfferListResponse, IVendorDetailOfferListParams>({
            query: (params) => ({
                url: apiV2ListLink.offer.list(Scenario.VENDOR_DETAIL_OFFER_LIST),
                method: "GET",
                params
            })
        })
    })
});

export const {useGetVendorDetailOffersQuery} = getVendorDetailOffers;
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IVendorOfferListResponse} from "../../offer/types/VendorOffersListResponse";
import {IVendorDetailOfferListParams} from "../types/IVendorDetailOfferListParams";

export const getVendorDetailOffers = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getVendorDetailOffers: builder.query<IVendorOfferListResponse, IVendorDetailOfferListParams>({
            query: (params) => ({
                url: apiV2ListLink.offer.list(Scenario.VENDOR_DETAIL_OFFER_LIST),
                method: "GET",
                params
            })
        })
    })
});

export const {useGetVendorDetailOffersQuery} = getVendorDetailOffers;
